export const menuList = ["Stocks", "Commodities", "Currencies", "F&O"];
